// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3h3rb","errorLogs":"styles_errorLogs__1RITs"};